module.exports = __webpack_public_path__ + "img/img3.fed1c663.jpg";